
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import ContentFragment from '@core/components/ContentFragment.vue';

interface Props {
  article: ArticleData;
  data: {
    isLoggedIn: boolean;
    profile: {
      displayName: string | null;
      id: number;
      email: string;
      firstName: string | null;
      lastName: string | null;
    };
  };
  openLoginModal: () => void;
  teaser: Record<string, any> | undefined;
}

interface Data {
  observer: MutationObserver | null;
  teaserComplete: boolean;
}

interface Methods {
  scrollToPaywall: () => void;
}

interface Computed {
  leadElement: ArticleData['content']['paywall']['teaser']['leadElement']['content'][0] | null;
}

interface PaywallWindow extends Window {
  jwplayer: any;
}

declare const window: PaywallWindow;

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    ContentFragment,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    openLoginModal: {
      type: Function,
      required: true,
    },
    teaser: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      observer: null,
      teaserComplete: false,
    };
  },
  computed: {
    leadElement() {
      const leadElement = this.teaser && this.teaser.leadElement;
      return leadElement && leadElement.content.length > 0 ? leadElement.content[0] : null;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (process.client && this.leadElement) {
        const callback = (mutations: any) => {
          const mutation = mutations[0] as MutationRecord;
          const nodes = mutation.addedNodes as NodeList;
          const node = nodes[0];
          const element = nodes[0] as HTMLElement;
          if (node && node.nodeName === 'DIV' && element.classList.contains('jwplayer')) {
            const player = window.jwplayer(element.id);
            player.off('complete');
            player.on('complete', () => {
              this.teaserComplete = true;
              player.remove();
            });
          }
        };

        const playerContainer = this.$refs.teaserPlayer as any;
        this.observer = new MutationObserver(callback);
        this.observer.observe(playerContainer.$el, { subtree: true, childList: true });
      }
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    scrollToPaywall() {
      const paywall = document.querySelector('#article-' + this.article.id + ' .C-fragment--teaser') as HTMLElement;
      paywall.scrollIntoView({ behavior: 'smooth' });
    },
  },
});
